// utils/sessionManager.js
export function handleSessionExpiry(navigate) {
  const expiry = localStorage.getItem("session_expiry");

  if (!expiry) return; // no impersonation session running

  const now = new Date().getTime();
  const remaining = expiry - now;

  if (remaining <= 0) {
    // session already expired
    localStorage.clear();
    alert("Session expired. Please login again."); // or Swal
    navigate("/"); // redirect to login/home
  } else {
    // session still valid -> schedule auto logout
    setTimeout(() => {
      localStorage.clear();
      alert("Session expired. Please login again."); // or Swal
      navigate("/");
    }, remaining);
  }
}
